export const calculatorGetHourServed = (timeSpent, serves) => {
  return ((timeSpent / 60) * (serves * 12)).toFixed(1);
};


export function minutesToNearestHour(minutes) {
  return Math.round(minutes / 60);
}
